import React from 'react';
import { Box, Paper, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { usePlatformInsets } from '../helpers/usePlatformInsets';

const BottomBar = ({ children, height = 64, style, ...props }) => {
    const theme = useTheme();
    const { bottomInset } = usePlatformInsets();
    const barPadding = 8 + bottomInset;

    return (
        <>
            {/* Spacer pushes content above the BottomBar */}
            <Box style={{ height: height + 26 + bottomInset, width: '100%', flexShrink: 0 }} />

            {/* Actual fixed BottomBar */}
            <Paper
                elevation={3}
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: height + bottomInset,
                    padding: `${8}px 16px ${barPadding}px`,
                    zIndex: theme.zIndex.appBar,
                    background: alpha(theme.palette.background.paper, 0.85),
                    backdropFilter: 'blur(10px)',
                    boxShadow: theme.shadows[4],
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxSizing: 'border-box',
                    ...style,
                }}
                {...props}
            >
                <Box
                    display="flex"
                    justifyContent="space-around"
                    alignItems="center"
                    width="100%"
                    maxWidth="600px"
                >
                    {children}
                </Box>
            </Paper>
        </>
    );
};

export default BottomBar;
